export default __webpack_public_path__ + "static/media/facility_02_2.d09d6d8c.png";